<template>
    <div class="creations-container">
        <div class="top">
            <div class="tabs">
                <div :class="['tab-item',{active:currTab == 1}]" @click="onTabClick(1)">Posts</div>
                <div :class="['tab-item',{active:currTab == 2}]" @click="onTabClick(2)">Drafts({{temp_count || '0'}})</div>
                <div :class="['tab-item',{active:currTab == 3}]" @click="onTabClick(3)">Collections({{ collect_count || '0' }})</div>
            </div>
            <div class="search-box">
                <input v-model="query.keyword" placeholder="search" type="text" @keyup.enter="onSearch" />
                <img src="../../assets/images/icon-search-workbench.png" @click="onSearch" />
            </div>
        </div>
        <div class="status-box" v-if="currTab == 1">
            <div :class="['status-item',{active:parseInt(query.status)===v.value}]" v-for="(v,k) in status_list" :key="`s`+k" @click="change_status(v.value)">
                {{v.name}}
                <span v-if="v.count > 0">({{v.count}})</span>
            </div>
        </div>
        <div v-if="currTab < 3" class="content-box">
            <div class="content-item" v-for="(item,index) in list" :key="`ll${index}`" @click.prevent.stop="onItemClick(item)">
                <div class="item-container" @click="onArticleDetail(item)">
                    <div class="cover-box">
                        <img :src="item.cover|default_img" alt="">
                        <div v-if="item.purview != 0" class="permission-status">{{item.permission_text}}</div>
                    </div>
                    <div class="content">
                        <div class="title"><span v-if="currTab == 1" :class="[item.status == 2 ? 'unpass' : item.status == 0 ? 'uncheck' :'']">{{ item.status|status_filter }}</span>{{ item.title ? item.title : 'No Title'}}</div>
                        <div class="datetime">{{currTab == 1 ? 'Published ' : 'Edited on:'}}{{(currTab == 1 ? item.last_publish_time : item.last_edit_time) | enDate}}</div>
                        <div class="count-box" v-if="currTab == 1">
                            <!-- <img src="../../assets/images/icon-views-creations.png"/> -->
                            <span>{{item.view_times | numberFormat}} views</span>
                            <!-- <img src="../../assets/images/icon-comment-creations.png" /> -->
                            <span>{{item.comment_count | numberFormat}} reviews</span>
                            <!-- <img src="../../assets/images/icon-like-creations.png" /> -->
                            <span>{{item.zan_count | numberFormat}} like</span>
                            <!-- <img src="../../assets/images/icon-collect-creations.png" /> -->
                            <span>{{item.collect_count | numberFormat}} Save</span>
                            <!-- <img src="../../assets/images/icon-share-creations.png" />
                            <span>0</span> -->
                        </div>
                        <!-- <div class="match-box" v-if="[1,3,5,6].includes(item) && currTab == 1">
                            <div class="match-text">
                                <img src="../../assets/images/icon-match-creations.png" />
                                <span>正在参加一个比赛比赛比赛比赛比赛比赛</span>
                            </div>
                        </div> -->
                        <div class="reason-box" v-if="item.reason && item.status == 2">
                            <div class="container">
                                <div class="reason-text">
                                    Review result: {{ item.reason }}
                                </div>
                            </div>
                        </div>
                        <div class="last-edit-time" v-if="currTab == 2">
                            Last modified:{{item.last_edit_time | enDate}}
                        </div>
                        <div class="bottom-box">
                            <Poptip placement="bottom" trigger="hover" padding="8px 5px" popper-class="permission-box" :transfer="true" v-if="currTab == 1">
                                <template #content>
                                    <div class="permission-box">
                                        <div class="permission-item" @click="onSetPostPermission(item.uuid,0)">
                                            <div class="permission-item-text">Publicly visible</div>
                                            <Icon v-if="item.purview == 0" type="md-checkmark" color="#ff5967" size="14"/>
                                        </div>
                                        <div class="permission-item" @click="onSetPostPermission(item.uuid,1)">
                                            <div class="permission-item-text">Visible to myself only</div>
                                            <Icon v-if="item.purview == 1" type="md-checkmark" color="#ff5967" size="14"/>
                                        </div>
                                        <div class="permission-item" @click="onSetPostPermission(item.uuid,2)">
                                            <div class="permission-item-text">Visible to mutual followers only</div>
                                            <Icon v-if="item.purview == 2" type="md-checkmark" color="#ff5967" size="14"/>
                                        </div>
                                    </div>
                                </template>
                                <div class="bottom-item" @click.prevent.stop>
                                    <img src="../../assets/images/icon-permission-lock.png"/>
                                    Permission Settings<Icon type="ios-arrow-down"/>
                                </div>
                            </Poptip>
                            <Poptip v-if="currTab == 1" placement="bottom" trigger="hover" padding="8px 5px" :transfer="true" popper-class="more-menu">
                                <template #content>
                                    <div class="more-item" @click.prevent.stop="onItemEdit(item)">
                                        <img src="../../assets/images/icon-edit-creation-list.png" class="icon-edit" />
                                        <img src="../../assets/images/icon-edit-creation-list-hover.png" class="icon-edit-hover" />
                                        Edit
                                    </div>
                                    <div class="more-item" @click.prevent.stop="onItemDelete(item)">
                                        <img src="../../assets/images/icon-delete-creations.png" class="icon-delete" />
                                        <img src="../../assets/images/icon-delete-hover.png" class="icon-delete-hover" />
                                        Delete
                                    </div>
                                </template>
                                <div class="more-ico">
                                    <img src="../../assets/images/icon-more.png" />
                                </div>
                            </Poptip>
                            <template v-else>
                                <div class="bottom-item" @click.prevent.stop="onItemEdit(item)">
                                        <img src="../../assets/images/icon-edit-creation-list.png"/>
                                        Edit
                                    </div>
                                    <div class="bottom-item" @click.prevent.stop="onItemDelete(item)">
                                        <img src="../../assets/images/icon-delete-creations.png" />
                                        Delete
                                    </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else
        class="masonry-container"
        style="margin-top: 30px; padding-bottom: 70px"
      >
        <masonry
          :cols="{ default: 5, 1600: 4, 1300: 3,1350:3,1250:3, 700: 3, 400: 2 }"
          :gutter="{ default: '30px',1600:'20px', 1300: '20px',1350:'15px',1250:'15px', 700: '15px', 400: '10px' }"
        >
          <div
            v-for="(item, index) in infiniteList"
            :key="index"
            @click.prevent.stop="onArticleDetail(item)"
          >
            <template>
              <div class="masonry-item">
                <img
                  v-if="item.type == 2"
                  src="../../assets/images/icon-play.png"
                  class="play-btn"
                  alt=""
                />
                <!-- <img src="../../assets/images/icon-match-on-list.png" class="match-ico" /> -->
                <div
                  class="remove-collect"
                  @click.prevent.stop="onCollectRemove(item)"
                >
                  Remove<Icon type="md-close"></Icon>
                </div>
                <div class="img-container">
                  <img
                    :src="item.cover"
                    @load="onImageLoad"
                    class="masonry-image"
                  />
                </div>
                <div class="item-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="bottom-box">
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-views-workbench-list.png"
                      />
                      <div style="margin-left: 3px">{{ item.view_times }}</div>
                    </div>
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-comment-workbench-list.png"
                      />
                      <div style="margin-left: 3px">
                        {{ item.comment_count }}
                      </div>
                    </div>
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-collect-workbench-list.png"
                      />
                      <div style="margin-left: 3px">{{ item.zan_count }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </masonry>
      </div>
        <div class="page-container" v-if="show_page && currTab != 3">
            <Page :total="total_page" :current="query.page" :page-size="query.limit" prev-text="Previous" next-text="Next" @on-change="onPageChange"></Page>
        </div>
        <ArticleDetail ref="articleDetail" v-if="show_detail" @on-close="onCloseArticleDetail" :uuid="uuid"></ArticleDetail>
    </div>
</template>
<script>
import { DeletePosts, GetMyCollectList, GetMyPostCount, GetMyPostList, PostsCollect, SetPostPermission } from '@/api/social';
import ArticleDetail from '@/components/ArticleDetail';
import infiniteMix from "@/mixins/infinite";
import _ from 'lodash';
export default{
    data(){
        return{
            currTab:1,
            temp_count:0,
            total_count:0,
            query:{
                keyword:"",
                page:1,
                limit:15,
                status:99
            },
            list_all:[],
            list_temp:[],
            status_list: {
                all: {name: 'ALL', value: 99, count: 0},
                publish: {name: 'Published', value: 3, count: 0},
                wait_auth: {name: 'Pending approval', value: 0, count: 0},
                reject: {name: 'Fail', value: 2, count: 0},
            },
            show_page:false,
            uuid:'',
            show_detail:false,
            collect_count:0
        }
    },
    filters:{
        status_filter(status){
            switch(status.toString()){
                case '0':
                    return 'Pending';
                case '2':
                    return 'Unpassed';

            }
        }
    },
    components:{
        ArticleDetail
    },
    mixins: [infiniteMix],
    computed:{
        total_page(){
            const {total_count,temp_count,currTab} = this;
            return currTab == 1 ? total_count : temp_count;
        },
        list(){
            const {currTab,list_all,list_temp} = this;
            switch(currTab.toString()){
                case '1':{
                    return list_all;
                }
                case '2':{
                    return list_temp;
                }
                default:{
                  return []
                }
            }
        }
    },
    watch:{
        total_page(news,olds){
            console.log('news-total-page',news);
        },
        'query.status'(){
            this.query.page = 1
            this.onGetList();
        }

    },
    async mounted(){
        window.addEventListener("scroll", this.handleScroll);
        const {type,uuid} = this.$route.query;
        if(type) this.currTab = type;
        if(uuid){
            this.query.status = 0;
            this.uuid = uuid;
            this.show_detail = true;
        }
        console.log('this.query',this.query);
        await this.onGetList();
        await this.onGetTempList();
        await this.getInfiniteList(true);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods:{
        async onCollectRemove(item) {
      console.log("remove-item", item);
      try {
        await PostsCollect({ uuid: item.uuid });
        this.$layer.msg("Successfully removed from favorites");
        this.getInfiniteList(true);
      } catch (e) {
        console.log("Exception when removing from favorites", e);
      }
    },
        async getInfiniteData(pageIndex, pageSize) {
      try {
        const { keyword } = this.query;
        const { data } = await GetMyCollectList({
          page: pageIndex,
          limit: pageSize,
          keyword,
        });
        const res = {};
        if (!data) {
          res.data = [];
          return res;
        }
        this.collect_count = data.count;
        res.data = data.list ? data.list : [];
        console.log("res", res);
        return res;
      } catch (e) {
        console.log("infiniteList", e);
        const res = {};
        res.data = [];
        return res;
      }
    },
    handleScroll: _.debounce(function() {
        console.log('aaaa');
      this.isBackToTopVisible = window.pageYOffset > 300; // Show when scrolled over 300px

      // Load more when reaching bottom
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      if (
        scrollTop + windowHeight >= documentHeight - 100 &&
        this.currTab === 3 &&
        !this.infiniteEnded
      ) {
        this.getInfiniteList();
      }
    }, 200),
        async onSetPostPermission(uuid,purview){
            return SetPostPermission({
                uuid: uuid,
                purview: purview
            }).then(response => {
                this.$layer.msg('Operation successful');
                this.onSearch();
            }).catch(err => {
                this.$layer.msg(err.msg)
            })

        },
        onArticleDetail(data){
            this.uuid = data.uuid.toString();
            this.show_detail = true;
        },
        onCloseArticleDetail(e){
            // console.log('关闭弹窗');
            this.show_detail = false;
        },
        change_status(s) {
            this.query.status = s
        },
        onTabClick(type){
            this.show_page = false;
            this.currTab = type;
            // this.total_count = 0;
            this.list_all = [];
            this.list_temp = [];
            this.query = {
                keyword:"",
                page:1,
                limit:15,
                status:'99'
            }
            if(this.currTab == 1){
                this.onGetList();
            }else if(this.currTab == 2){
                this.onGetTempList();
            }else{
                this.getInfiniteList(true);
            }
        },
        onGetTempList:_.debounce(async function(){
            try{
                this.list_temp = [];
                const {query} = this;
                const {keyword,page,limit} = query;
                const {data} = await GetMyPostList({keyword,page,limit,status:-1});
                this.temp_count = data.count;
                if(!data.list.length) return;
                this.list_temp = data.list;
            }catch(e){
                console.log('ee',e);
            }finally{
                this.show_page = true;
            }
        },100),
        onGetList:_.debounce(async function(){
            try{
                this.show_page = false;
                // this.total_count = 0;
                this.list_all = [];
                const {data} = await GetMyPostList(this.query);
                this.list_all = data.list;
                this.total_count = data.count || 0;
                const response = await GetMyPostCount(this.query);
                for(let code in response.data){
                    this.status_list[code].count = response.data[code];
                }
                this.$forceUpdate();
            }finally{
                this.show_page = true;
            }
        },100),
        onPageChange(e){
            console.log("page-change",e);
            this.query.page = e;
            if(this.currTab == 1){
                this.onGetList();
            }else{
                this.onGetTempList();
            }
        },
        onItemDelete(item){
            console.log('delete-item',item);
            this.$DModal.confirm({
                content: 'Confirm to delete this note?',
                okText:'Confirm',
                cancelText:'Cancel',
                onOK: async () => {
                    try{
                        await DeletePosts({uuid:item.uuid});
                        const {currTab} = this;
                        this.list_all = [];
                        this.list_temp = [];
                        this.$layer.msg('Delete Successful');
                        this.query.page = 1;
                        currTab == 1 ? this.onGetList() : this.onGetTempList();
                    }catch(e){
                        console.log('eee-delete',e);
                    }
                }
            })
        },
        onItemEdit(item){
            console.log('edit-item',item);
            this.$router.push({name:'Posts',params:{uuid:item.uuid}})
        },
        onItemClick(item){
            console.log('click-item',item);
        },
        onSearch(){
            const {currTab} = this;
            switch(currTab){
                case 1:
                    this.onGetList();
                    break;
                case 2:
                    this.onGetTempList();
                    break;
            }
        },
        onImageLoad() {
            this.$nextTick(() => {
                this.$refs.masonryWall?.reCalculate();
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import './mycreations.scss';

/**瀑布流样式开始 */
  .masonry-container {
    max-width: 1520px;
    margin: 0 auto;
    .masonry-item {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      width: 236px;
      cursor: pointer;
      position: relative;
      .remove-collect {
        display: none;
      }
      &:hover .remove-collect {
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        color: white;
        font-size: 14px;
        line-height: normal;
        padding: 4px 14px;
        border-bottom-right-radius: 10px;
        border-top-left-radius: 10px;
        display: flex;
        align-items: center;
        z-index: 10;
      }
      .play-btn {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .match-ico {
        position: absolute;
        width: 32px;
        height: 32px;
        right: 10px;
        bottom: 100px;
      }

      .img-container {
        position: relative;
        display: inline-block;
        width: fit-content;
        img {
          display: block;
          width: 100%;
          height: auto;
        }

        &:hover::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(128, 128, 128, 0.4);
          pointer-events: none;
          border-radius: 10px;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(128, 128, 128, 0.05);
          pointer-events: none;
          border-radius: 10px;
        }

        .masonry-image {
          width: 100%;
          display: block;
          object-fit: contain;
          border-radius: 10px;
        }
      }

      .item-content {
        padding: 15px 5px;
        .title {
          font-size: 16px;
          color: #000000;
        }
        .bottom-box {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;

          .bottom-item {
            display: flex;
            align-items: center;
            &:nth-child(2) {
              margin-left: 10px;
              margin-right: 10px;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }

          .views-box {
            display: flex;
            align-items: center;
          }

          .comment-box {
            display: flex;
            align-items: center;
          }

          .like-box {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  /* 响应式调整列数 */
  @media (max-width: 768px) {
    .masonry-container {
      --columns: 2;
    }
  }

  @media (max-width: 480px) {
    .masonry-container {
      --columns: 1;
    }
  }
  /**瀑布流样式结束 */
</style>
